import {FreedomEditor} from "./FreedomEditor";

interface ReplyEditRowProps {
    setter: any;
    data: { body: string, fileVOList: { fileKey: string }[] };
    removeFile: (key: string) => void;
    handleButtonClick: () => void;
    UploadUI: any;
    updateReply: () => void;
    onCanceled: () => void;
}

export default function ReplyEditRow(props: ReplyEditRowProps) {
    const {setter, data, removeFile, handleButtonClick, UploadUI, updateReply, onCanceled} = props;
    return <>
        <div style={{height: "249px"}}>
            <th colSpan={2}>내용</th>
            <td className="p-4px" style={{verticalAlign: "top"}}>
                <FreedomEditor
                    setValue={setter}
                    value={data.body}
                    fieldName={'body'}
                    height={230}/>
            </td>
        </div>
        <div>
            <th colSpan={2}>첨부파일</th>
            <td className="p-4px">
                <div className="tbl_files_outer">
                    {data?.fileVOList && <ul className="list_files">
                        {(data?.fileVOList ?? []).map((item: any) => <li>
                            <a>{item.fileOrgname}</a>
                            <button
                                className="btn btn-link p-0"
                                onClick={() => removeFile(item.fileKey)}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_deltoken.png"} alt=""/>
                            </button>
                        </li>)}
                    </ul>}
                    <button
                        className="btn btn-outline-secondary"
                        onClick={() => handleButtonClick()}>파일 업로드
                    </button>
                    <UploadUI/>
                </div>
            </td>
        </div>
        <div className="d-flex  justify-content-end">
            <button className="btn btn-info w-100px h-38px me-5px" onClick={() => updateReply()}>저장</button>
            <button className="btn btn-outline-secondary w-100px h-38px" onClick={() => onCanceled()}>취소</button>
        </div>
    </>
}